import { default as affiliation_45linky5UcCNZqirMeta } from "/opt/build/repo/pages/affiliation-link.vue?macro=true";
import { default as redirectahlnn68g1BMeta } from "/opt/build/repo/pages/auth/redirect.vue?macro=true";
import { default as batch_45qrcode0vaM0ID56OMeta } from "/opt/build/repo/pages/batch-qrcode.vue?macro=true";
import { default as batch_45short_45linksAvmyYejEZNMeta } from "/opt/build/repo/pages/batch-short-links.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as latest_45books44VuQ8tpSoMeta } from "/opt/build/repo/pages/latest-books.vue?macro=true";
import { default as index64z3xhFYw2Meta } from "/opt/build/repo/pages/nft-book-store/collection/index.vue?macro=true";
import { default as new0AB3vxGRtmMeta } from "/opt/build/repo/pages/nft-book-store/collection/new.vue?macro=true";
import { default as _91collectionId_93fXxrCui1SMMeta } from "/opt/build/repo/pages/nft-book-store/collection/send/[collectionId].vue?macro=true";
import { default as _91collectionId_93Ztwxpv0MYgMeta } from "/opt/build/repo/pages/nft-book-store/collection/send/shipping/[collectionId].vue?macro=true";
import { default as editSTlMClhQ8FMeta } from "/opt/build/repo/pages/nft-book-store/collection/status/[collectionId]/edit.vue?macro=true";
import { default as _91collectionId_93MMuPdge0PIMeta } from "/opt/build/repo/pages/nft-book-store/collection/status/[collectionId].vue?macro=true";
import { default as _91classId_93UKJP1dVRbgMeta } from "/opt/build/repo/pages/nft-book-store/gift/[classId].vue?macro=true";
import { default as indexlCpwSdLztGMeta } from "/opt/build/repo/pages/nft-book-store/index.vue?macro=true";
import { default as newjXItUVQ83ZMeta } from "/opt/build/repo/pages/nft-book-store/new.vue?macro=true";
import { default as _91classId_93nssiqQUNwLMeta } from "/opt/build/repo/pages/nft-book-store/send/[classId].vue?macro=true";
import { default as _91classId_93QHhNVhcsFNMeta } from "/opt/build/repo/pages/nft-book-store/send/shipping/[classId].vue?macro=true";
import { default as _91editionIndex_93OM8V7CkMK6Meta } from "/opt/build/repo/pages/nft-book-store/status/[classId]/edit/[editionIndex].vue?macro=true";
import { default as newW7TSS4KVnAMeta } from "/opt/build/repo/pages/nft-book-store/status/[classId]/edit/new.vue?macro=true";
import { default as _91classId_93i6t3CYEGznMeta } from "/opt/build/repo/pages/nft-book-store/status/[classId].vue?macro=true";
import { default as refreshq8QJkIRDmVMeta } from "/opt/build/repo/pages/nft-book-store/user/connect/refresh.vue?macro=true";
import { default as returnpJjodc4CqiMeta } from "/opt/build/repo/pages/nft-book-store/user/connect/return.vue?macro=true";
import { default as indexrF73zkntFxMeta } from "/opt/build/repo/pages/nft-book-store/user/index.vue?macro=true";
import { default as _91payoutId_933pX2FQfQ23Meta } from "/opt/build/repo/pages/nft-book-store/user/payouts/[payoutId].vue?macro=true";
import { default as nft_45book_45storeP1vydaqgsaMeta } from "/opt/build/repo/pages/nft-book-store.vue?macro=true";
import { default as indexDwurmme7toMeta } from "/opt/build/repo/pages/publish-nft-book/index.vue?macro=true";
import { default as publish_45nft_45bookDoDVFO9ObkMeta } from "/opt/build/repo/pages/publish-nft-book.vue?macro=true";
import { default as purchase_45linkhPjzoB6kuyMeta } from "/opt/build/repo/pages/purchase-link.vue?macro=true";
import { default as indexyiKgE0tMCLMeta } from "/opt/build/repo/pages/sales-pos/index.vue?macro=true";
export default [
  {
    name: "affiliation-link",
    path: "/affiliation-link",
    component: () => import("/opt/build/repo/pages/affiliation-link.vue")
  },
  {
    name: "auth-redirect",
    path: "/auth/redirect",
    meta: redirectahlnn68g1BMeta || {},
    component: () => import("/opt/build/repo/pages/auth/redirect.vue")
  },
  {
    name: "batch-qrcode",
    path: "/batch-qrcode",
    meta: batch_45qrcode0vaM0ID56OMeta || {},
    component: () => import("/opt/build/repo/pages/batch-qrcode.vue")
  },
  {
    name: "batch-short-links",
    path: "/batch-short-links",
    component: () => import("/opt/build/repo/pages/batch-short-links.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "latest-books",
    path: "/latest-books",
    component: () => import("/opt/build/repo/pages/latest-books.vue")
  },
  {
    name: nft_45book_45storeP1vydaqgsaMeta?.name,
    path: "/nft-book-store",
    component: () => import("/opt/build/repo/pages/nft-book-store.vue"),
    children: [
  {
    name: "nft-book-store-collection",
    path: "collection",
    component: () => import("/opt/build/repo/pages/nft-book-store/collection/index.vue")
  },
  {
    name: "nft-book-store-collection-new",
    path: "collection/new",
    component: () => import("/opt/build/repo/pages/nft-book-store/collection/new.vue")
  },
  {
    name: "nft-book-store-collection-send-collectionId",
    path: "collection/send/:collectionId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/collection/send/[collectionId].vue")
  },
  {
    name: "nft-book-store-collection-send-shipping-collectionId",
    path: "collection/send/shipping/:collectionId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/collection/send/shipping/[collectionId].vue")
  },
  {
    name: "nft-book-store-collection-status-collectionId",
    path: "collection/status/:collectionId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/collection/status/[collectionId].vue"),
    children: [
  {
    name: "nft-book-store-collection-status-collectionId-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/nft-book-store/collection/status/[collectionId]/edit.vue")
  }
]
  },
  {
    name: "nft-book-store-gift-classId",
    path: "gift/:classId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/gift/[classId].vue")
  },
  {
    name: "nft-book-store",
    path: "",
    component: () => import("/opt/build/repo/pages/nft-book-store/index.vue")
  },
  {
    name: "nft-book-store-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/nft-book-store/new.vue")
  },
  {
    name: "nft-book-store-send-classId",
    path: "send/:classId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/send/[classId].vue")
  },
  {
    name: "nft-book-store-send-shipping-classId",
    path: "send/shipping/:classId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/send/shipping/[classId].vue")
  },
  {
    name: "nft-book-store-status-classId",
    path: "status/:classId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/status/[classId].vue"),
    children: [
  {
    name: "nft-book-store-status-classId-edit-editionIndex",
    path: "edit/:editionIndex()",
    component: () => import("/opt/build/repo/pages/nft-book-store/status/[classId]/edit/[editionIndex].vue")
  },
  {
    name: "nft-book-store-status-classId-edit-new",
    path: "edit/new",
    component: () => import("/opt/build/repo/pages/nft-book-store/status/[classId]/edit/new.vue")
  }
]
  },
  {
    name: "nft-book-store-user-connect-refresh",
    path: "user/connect/refresh",
    meta: refreshq8QJkIRDmVMeta || {},
    component: () => import("/opt/build/repo/pages/nft-book-store/user/connect/refresh.vue")
  },
  {
    name: "nft-book-store-user-connect-return",
    path: "user/connect/return",
    meta: returnpJjodc4CqiMeta || {},
    component: () => import("/opt/build/repo/pages/nft-book-store/user/connect/return.vue")
  },
  {
    name: "nft-book-store-user",
    path: "user",
    component: () => import("/opt/build/repo/pages/nft-book-store/user/index.vue")
  },
  {
    name: "nft-book-store-user-payouts-payoutId",
    path: "user/payouts/:payoutId()",
    component: () => import("/opt/build/repo/pages/nft-book-store/user/payouts/[payoutId].vue")
  }
]
  },
  {
    name: publish_45nft_45bookDoDVFO9ObkMeta?.name,
    path: "/publish-nft-book",
    component: () => import("/opt/build/repo/pages/publish-nft-book.vue"),
    children: [
  {
    name: "publish-nft-book",
    path: "",
    component: () => import("/opt/build/repo/pages/publish-nft-book/index.vue")
  }
]
  },
  {
    name: "purchase-link",
    path: "/purchase-link",
    component: () => import("/opt/build/repo/pages/purchase-link.vue")
  },
  {
    name: "sales-pos",
    path: "/sales-pos",
    component: () => import("/opt/build/repo/pages/sales-pos/index.vue")
  }
]